module.exports = __webpack_public_path__ + "img/icon-alert_triangle.78cefbb6.svg";